module.exports = __webpack_public_path__ + "static/5-51d45d8850b440d645c134611f10eac5.jpeg";